import { useTypewriter } from '../../hooks/use-typewriter';

interface TypewriterProps {
  /** 要逐字打出的文本(locale 切换后传入新值会自动重打)。 */
  text: string;
  /** 为 false 时直接全显。默认 true。 */
  enabled?: boolean;
}

/**
 * 欢迎语打字机 —— 逐字变速打出,末尾跟一个闪烁光标(打字完成后隐藏)。
 * 打字节点 aria-hidden,另附 dcs-sr-only 全文节点供读屏一次性读出。
 */
export function Typewriter({ text, enabled = true }: TypewriterProps) {
  const { display, done } = useTypewriter(text, { enabled });
  return (
    <>
      <span aria-hidden="true">
        {display}
        {!done && <span class="dcs-tw-cursor" aria-hidden="true" />}
      </span>
      <span class="dcs-sr-only">{text}</span>
    </>
  );
}
